(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-design-search-results"]) return;
  try {
    
  (()=>{
    const root=document.querySelector('[data-design-search-page]');
    if(!root)return;
    const endpoint=root.dataset.searchApi||'/apps/design-engine/design-search';
    const input=root.querySelector('[data-search-page-input]');
    const heading=root.querySelector('[data-search-page-heading]');
    const status=root.querySelector('[data-search-page-status]');
    const garment=root.querySelector('[data-search-page-garment]');
    const grid=root.querySelector('[data-search-page-grid]');
    const loading=root.querySelector('[data-search-page-loading]');
    const empty=root.querySelector('[data-search-page-empty]');
    const start=root.querySelector('[data-search-page-start]');
    const failure=root.querySelector('[data-search-page-error]');
    const query=new URLSearchParams(window.location.search).get('q')?.trim()||'';
    const randomId=()=>window.crypto?.randomUUID?.()||Date.now()+'_'+Math.random().toString(36).slice(2);
    let sessionId='';
    try{sessionId=sessionStorage.getItem('et_design_search_session')||randomId();sessionStorage.setItem('et_design_search_session',sessionId)}catch{sessionId=randomId()}

    function showOnly(target){
      [loading,empty,start,failure].forEach(node=>node.hidden=node!==target);
    }

    function card(result){
      const link=document.createElement('a');
      link.className='et-design-search-page__card';
      link.href=result.url;
      link.dataset.designSearchResult='';
      link.dataset.designId=String(result.designId||'');
      const imageWrap=document.createElement('div');
      imageWrap.className='et-design-search-page__image';
      const image=document.createElement('img');
      image.src=result.image;
      image.alt=result.title+' design artwork';
      image.width=700;
      image.height=700;
      image.loading='lazy';
      imageWrap.appendChild(image);
      const copy=document.createElement('div');
      copy.className='et-design-search-page__copy';
      if(result.primaryTopic){const topic=document.createElement('p');topic.textContent=result.primaryTopic;copy.appendChild(topic)}
      const title=document.createElement('h2');title.textContent=result.title;copy.appendChild(title);
      if(result.subtitle){const subtitle=document.createElement('span');subtitle.textContent=result.subtitle;copy.appendChild(subtitle)}
      const action=document.createElement('strong');action.textContent='Explore this design →';copy.appendChild(action);
      link.append(imageWrap,copy);
      return link;
    }

    function showGarment(match){
      garment.replaceChildren();
      if(!match){garment.hidden=true;return}
      const link=document.createElement('a');
      link.href=match.url;
      const copy=document.createElement('span');
      const title=document.createElement('strong');title.textContent='Shop '+match.label;
      const note=document.createElement('small');note.textContent='Browse all designs in this style';
      const arrow=document.createElement('b');arrow.textContent='→';arrow.setAttribute('aria-hidden','true');
      copy.append(title,note);link.append(copy,arrow);garment.appendChild(link);garment.hidden=false;
    }

    if(!query){
      heading.textContent='Search designs';
      status.textContent='';
      showOnly(start);
      return;
    }

    input.value=query;
    heading.textContent='Search results for “'+query+'”';
    showOnly(loading);
    const searchId=randomId();
    const url=new URL(endpoint,window.location.origin);
    url.searchParams.set('q',query);
    url.searchParams.set('limit','48');
    url.searchParams.set('search_id',searchId);
    url.searchParams.set('session_id',sessionId);
    url.searchParams.set('mode','completed');
    url.searchParams.set('source','results_page');

    fetch(url.toString(),{headers:{Accept:'application/json'}}).then(response=>{
      if(!response.ok)throw new Error('Search request failed');
      return response.json();
    }).then(data=>{
      loading.hidden=true;
      grid.replaceChildren();
      showGarment(data.garment);
      if(!data.results?.length){
        if(data.garment){status.textContent='Garment match for “'+query+'”.';[empty,start,failure].forEach(node=>node.hidden=true);return}
        status.textContent='No designs matched “'+query+'”.';showOnly(empty);return
      }
      [empty,start,failure].forEach(node=>node.hidden=true);
      data.results.forEach(result=>grid.appendChild(card(result)));
      const total=Number(data.total||data.results.length);
      status.textContent=total>data.results.length?'Showing '+data.results.length+' of '+total+' matching designs':'Showing '+total+' matching '+(total===1?'design':'designs');
      root.dataset.searchId=data.search_id||searchId;
      root.dataset.resultCount=String(total);
    }).catch(()=>{grid.replaceChildren();status.textContent='';showOnly(failure)});

    grid.addEventListener('click',event=>{
      const link=event.target.closest('[data-design-search-result]');
      const savedSearchId=root.dataset.searchId;
      if(!link||!savedSearchId)return;
      const clickUrl=new URL(endpoint,window.location.origin);
      clickUrl.searchParams.set('event','click');
      clickUrl.searchParams.set('q',query);
      clickUrl.searchParams.set('search_id',savedSearchId);
      clickUrl.searchParams.set('session_id',sessionId);
      clickUrl.searchParams.set('design_id',link.dataset.designId||'');
      clickUrl.searchParams.set('result_count',root.dataset.resultCount||'0');
      clickUrl.searchParams.set('source','results_page');
      fetch(clickUrl.toString(),{headers:{Accept:'application/json'},keepalive:true}).catch(()=>{});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
